import type { ButtonConfig } from 'src/components/root/components/buttons/declare'
import { useContext } from 'react'
import { Button, message } from 'antd'
import { EasyIcon, EditPropsContext, EditContext, EllipsisTextView, postMsg } from 'src/components'
import { mainStore } from 'enasops/stores'
import { $api } from 'src/plugins'
import { getNavFieldsFromNavColumns, getEditSubPageNavFields } from 'src/components/root/helper'
import { initFilter, extendRules, getSingleRule, extendInclude } from 'src/utils/common'
import { pick } from 'lodash'

const Version = (props: { config: ButtonConfig }) => {
  const editProps = useContext(EditPropsContext)
  const edit = useContext(EditContext)

  const handlePublish = () => {
    const isInvalid = edit?.checkVerifyIsInvalid()
    if (isInvalid) {
      postMsg('表单输入有误，请检查必填项', 'error')
      return
    }

    const payload = pick(edit.formBase, ['VERSION_NUMBER', 'VERSION_CONTENT'])
    $api['app/getDataByPost'](
      {
        ...payload,
        ORG_ID: mainStore.headers.OrgId
      },
      { url: '/OP/EquipmentTypeVersion/Update' }
    ).then(res => {
      if (res) {
        message.success('发布成功')

        const { Nav_PageEdit = {}, Nav_SubPageEdits = [] } = edit.editConfig
        const { Nav_PageEdit: deepConfig, Nav_Columns } = Nav_PageEdit
        const { OrgId } = mainStore.headers
        const payload = initFilter({ OrgId })
        extendRules(payload, [getSingleRule('ID', 1, editProps.formData?.formId!)])
        // 编辑表单导航属性
        const pageNavFields = getNavFieldsFromNavColumns(Nav_Columns)
        // 编辑表单子表导航属性
        const subPageNavFields = getEditSubPageNavFields(Nav_SubPageEdits)
        const navFields = pageNavFields.concat(subPageNavFields)
        navFields.length && extendInclude(payload, navFields)
        $api['app/getDataByPost'](payload, {
          url: deepConfig.QUERY_API_URL
        }).then((res: any) => {
          res && edit.editPageTable.activeTable.setDataSource(res.Nav_Detail)
        })
      }
    })
  }

  const { LABEL, ICON } = props.config
  return (
    <Button
      type='primary'
      icon={<EasyIcon type={ICON} defaultIcon='FileTextOutlined' />}
      onClick={handlePublish}
    >
      {LABEL}
    </Button>
  )
}

export default {
  renderPublish (EditContext: any, props: any) {
    return <Version {...props} />
  },
  renderContent (text: string) {
    return <div style={{ width: 240 }}><EllipsisTextView text={text} /></div>
  }
}